module.exports = __webpack_public_path__ + "img/image14.6ad1fe8e.png";